
import LocalizedStrings from 'react-localization';
let countries = new LocalizedStrings({
    fi:
    {
        countryNames: {
            "FI": "Suomi",
            "AC": "Ascension-saari",
            "AD": "Andorra",
            "AE": "Arabiemiirikunnat",
            "AF": "Afganistan",
            "AG": "Antigua ja Barbuda",
            "AI": "Anguilla",
            "AL": "Albania",
            "AM": "Armenia",
            "AO": "Angola",
            "AQ": "Antarktis",
            "AR": "Argentiina",
            "AS": "Amerikan Samoa",
            "AT": "Itävalta",
            "AU": "Australia",
            "AW": "Aruba",
            "AX": "Ahvenanmaa",
            "AZ": "Azerbaidžan",
            "BA": "Bosnia ja Hertsegovina",
            "BB": "Barbados",
            "BD": "Bangladesh",
            "BE": "Belgia",
            "BF": "Burkina Faso",
            "BG": "Bulgaria",
            "BH": "Bahrain",
            "BI": "Burundi",
            "BJ": "Benin",
            "BL": "Saint-Barthélemy",
            "BM": "Bermuda",
            "BN": "Brunei",
            "BO": "Bolivia",
            "BQ": "Karibian Alankomaat",
            "BR": "Brasilia",
            "BS": "Bahama",
            "BT": "Bhutan",
            "BV": "Bouvet’nsaari",
            "BW": "Botswana",
            "BY": "Valko-Venäjä",
            "BZ": "Belize",
            "CA": "Kanada",
            "CC": "Kookossaaret (Keelingsaaret)",
            "CD": "Kongon demokraattinen tasavalta",
            "CF": "Keski-Afrikan tasavalta",
            "CG": "Kongon tasavalta",
            "CH": "Sveitsi",
            "CI": "Norsunluurannikko",
            "CK": "Cookinsaaret",
            "CL": "Chile",
            "CM": "Kamerun",
            "CN": "Kiina",
            "CO": "Kolumbia",
            "CP": "Clippertoninsaari",
            "CR": "Costa Rica",
            "CU": "Kuuba",
            "CV": "Kap Verde",
            "CW": "Curaçao",
            "CX": "Joulusaari",
            "CY": "Kypros",
            "CZ": "Tšekki",
            "DE": "Saksa",
            "DG": "Diego Garcia",
            "DJ": "Djibouti",
            "DK": "Tanska",
            "DM": "Dominica",
            "DO": "Dominikaaninen tasavalta",
            "DZ": "Algeria",
            "EA": "Ceuta ja Melilla",
            "EC": "Ecuador",
            "EE": "Viro",
            "EG": "Egypti",
            "EH": "Länsi-Sahara",
            "ER": "Eritrea",
            "ES": "Espanja",
            "ET": "Etiopia",
            "FJ": "Fidži",
            "FK": "Falklandinsaaret",
            "FM": "Mikronesia",
            "FO": "Färsaaret",
            "FR": "Ranska",
            "GA": "Gabon",
            "GB": "Iso-Britannia",
            "GD": "Grenada",
            "GE": "Georgia",
            "GF": "Ranskan Guayana",
            "GG": "Guernsey",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GL": "Grönlanti",
            "GM": "Gambia",
            "GN": "Guinea",
            "GP": "Guadeloupe",
            "GQ": "Päiväntasaajan Guinea",
            "GR": "Kreikka",
            "GS": "Etelä-Georgia ja Eteläiset Sandwichinsaaret",
            "GT": "Guatemala",
            "GU": "Guam",
            "GW": "Guinea-Bissau",
            "GY": "Guyana",
            "HK": "Hongkong – Kiinan erityishallintoalue",
            "HM": "Heard ja McDonaldinsaaret",
            "HN": "Honduras",
            "HR": "Kroatia",
            "HT": "Haiti",
            "HU": "Unkari",
            "IC": "Kanariansaaret",
            "ID": "Indonesia",
            "IE": "Irlanti",
            "IL": "Israel",
            "IM": "Mansaari",
            "IN": "Intia",
            "IO": "Brittiläinen Intian valtameren alue",
            "IQ": "Irak",
            "IR": "Iran",
            "IS": "Islanti",
            "IT": "Italia",
            "JE": "Jersey",
            "JM": "Jamaika",
            "JO": "Jordania",
            "JP": "Japani",
            "KE": "Kenia",
            "KG": "Kirgisia",
            "KH": "Kambodža",
            "KI": "Kiribati",
            "KM": "Komorit",
            "KN": "Saint Kitts ja Nevis",
            "KP": "Pohjois-Korea",
            "KR": "Etelä-Korea",
            "KW": "Kuwait",
            "KY": "Caymansaaret",
            "KZ": "Kazakstan",
            "LA": "Laos",
            "LB": "Libanon",
            "LC": "Saint Lucia",
            "LI": "Liechtenstein",
            "LK": "Sri Lanka",
            "LR": "Liberia",
            "LS": "Lesotho",
            "LT": "Liettua",
            "LU": "Luxemburg",
            "LV": "Latvia",
            "LY": "Libya",
            "MA": "Marokko",
            "MC": "Monaco",
            "MD": "Moldova",
            "ME": "Montenegro",
            "MF": "Saint-Martin",
            "MG": "Madagaskar",
            "MH": "Marshallinsaaret",
            "MK": "Pohjois-Makedonia",
            "ML": "Mali",
            "MM": "Myanmar (Burma)",
            "MN": "Mongolia",
            "MO": "Macao – Kiinan erityishallintoalue",
            "MP": "Pohjois-Mariaanit",
            "MQ": "Martinique",
            "MR": "Mauritania",
            "MS": "Montserrat",
            "MT": "Malta",
            "MU": "Mauritius",
            "MV": "Malediivit",
            "MW": "Malawi",
            "MX": "Meksiko",
            "MY": "Malesia",
            "MZ": "Mosambik",
            "NA": "Namibia",
            "NC": "Uusi-Kaledonia",
            "NE": "Niger",
            "NF": "Norfolkinsaari",
            "NG": "Nigeria",
            "NI": "Nicaragua",
            "NL": "Alankomaat",
            "NO": "Norja",
            "NP": "Nepal",
            "NR": "Nauru",
            "NU": "Niue",
            "NZ": "Uusi-Seelanti",
            "OM": "Oman",
            "PA": "Panama",
            "PE": "Peru",
            "PF": "Ranskan Polynesia",
            "PG": "Papua-Uusi-Guinea",
            "PH": "Filippiinit",
            "PK": "Pakistan",
            "PL": "Puola",
            "PM": "Saint-Pierre ja Miquelon",
            "PN": "Pitcairn",
            "PR": "Puerto Rico",
            "PS": "Palestiinalaisalue",
            "PT": "Portugali",
            "PW": "Palau",
            "PY": "Paraguay",
            "QA": "Qatar",
            "QO": "Oseanian erillissaaret",
            "RE": "Réunion",
            "RO": "Romania",
            "RS": "Serbia",
            "RU": "Venäjä",
            "RW": "Ruanda",
            "SA": "Saudi-Arabia",
            "SB": "Salomonsaaret",
            "SC": "Seychellit",
            "SD": "Sudan",
            "SE": "Ruotsi",
            "SG": "Singapore",
            "SH": "Saint Helena",
            "SI": "Slovenia",
            "SJ": "Svalbard ja Jan Mayen",
            "SK": "Slovakia",
            "SL": "Sierra Leone",
            "SM": "San Marino",
            "SN": "Senegal",
            "SO": "Somalia",
            "SR": "Suriname",
            "SS": "Etelä-Sudan",
            "ST": "São Tomé ja Príncipe",
            "SV": "El Salvador",
            "SX": "Sint Maarten",
            "SY": "Syyria",
            "SZ": "Eswatini",
            "TA": "Tristan da Cunha",
            "TC": "Turks- ja Caicossaaret",
            "TD": "Tšad",
            "TF": "Ranskan eteläiset ja antarktiset alueet",
            "TG": "Togo",
            "TH": "Thaimaa",
            "TJ": "Tadžikistan",
            "TK": "Tokelau",
            "TL": "Itä-Timor",
            "TM": "Turkmenistan",
            "TN": "Tunisia",
            "TO": "Tonga",
            "TR": "Turkki",
            "TT": "Trinidad ja Tobago",
            "TV": "Tuvalu",
            "TW": "Taiwan",
            "TZ": "Tansania",
            "UA": "Ukraina",
            "UG": "Uganda",
            "UM": "Yhdysvaltain erillissaaret",
            "US": "Yhdysvallat",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VA": "Vatikaani",
            "VC": "Saint Vincent ja Grenadiinit",
            "VE": "Venezuela",
            "VG": "Brittiläiset Neitsytsaaret",
            "VI": "Yhdysvaltain Neitsytsaaret",
            "VN": "Vietnam",
            "VU": "Vanuatu",
            "WF": "Wallis ja Futuna",
            "WS": "Samoa",
            "XK": "Kosovo",
            "YE": "Jemen",
            "YT": "Mayotte",
            "ZA": "Etelä-Afrikka",
            "ZM": "Sambia",
            "ZW": "Zimbabwe",
        }
    },
    sv:
    {
        countryNames: {
            "SE": "Sverige",
            "AC": "Ascension",
            "AD": "Andorra",
            "AE": "Förenade Arabemiraten",
            "AF": "Afghanistan",
            "AG": "Antigua och Barbuda",
            "AI": "Anguilla",
            "AL": "Albanien",
            "AM": "Armenien",
            "AO": "Angola",
            "AQ": "Antarktis",
            "AR": "Argentina",
            "AS": "Amerikanska Samoa",
            "AT": "Österrike",
            "AU": "Australien",
            "AW": "Aruba",
            "AX": "Åland",
            "AZ": "Azerbajdzjan",
            "BA": "Bosnien och Hercegovina",
            "BB": "Barbados",
            "BD": "Bangladesh",
            "BE": "Belgien",
            "BF": "Burkina Faso",
            "BG": "Bulgarien",
            "BH": "Bahrain",
            "BI": "Burundi",
            "BJ": "Benin",
            "BL": "S:t Barthélemy",
            "BM": "Bermuda",
            "BN": "Brunei",
            "BO": "Bolivia",
            "BQ": "Karibiska Nederländerna",
            "BR": "Brasilien",
            "BS": "Bahamas",
            "BT": "Bhutan",
            "BV": "Bouvetön",
            "BW": "Botswana",
            "BY": "Vitryssland",
            "BZ": "Belize",
            "CA": "Kanada",
            "CC": "Kokosöarna",
            "CD": "Kongo-Kinshasa",
            "CF": "Centralafrikanska republiken",
            "CG": "Kongo-Brazzaville",
            "CH": "Schweiz",
            "CI": "Côte d’Ivoire",
            "CK": "Cooköarna",
            "CL": "Chile",
            "CM": "Kamerun",
            "CN": "Kina",
            "CO": "Colombia",
            "CP": "Clippertonön",
            "CR": "Costa Rica",
            "CU": "Kuba",
            "CV": "Kap Verde",
            "CW": "Curaçao",
            "CX": "Julön",
            "CY": "Cypern",
            "CZ": "Tjeckien",
            "DE": "Tyskland",
            "DG": "Diego Garcia",
            "DJ": "Djibouti",
            "DK": "Danmark",
            "DM": "Dominica",
            "DO": "Dominikanska republiken",
            "DZ": "Algeriet",
            "EA": "Ceuta och Melilla",
            "EC": "Ecuador",
            "EE": "Estland",
            "EG": "Egypten",
            "EH": "Västsahara",
            "ER": "Eritrea",
            "ES": "Spanien",
            "ET": "Etiopien",       
            "FI": "Finland",
            "FJ": "Fiji",
            "FK": "Falklandsöarna",
            "FM": "Mikronesien",
            "FO": "Färöarna",
            "FR": "Frankrike",
            "GA": "Gabon",
            "GB": "Storbritannien",
            "GD": "Grenada",
            "GE": "Georgien",
            "GF": "Franska Guyana",
            "GG": "Guernsey",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GL": "Grönland",
            "GM": "Gambia",
            "GN": "Guinea",
            "GP": "Guadeloupe",
            "GQ": "Ekvatorialguinea",
            "GR": "Grekland",
            "GS": "Sydgeorgien och Sydsandwichöarna",
            "GT": "Guatemala",
            "GU": "Guam",
            "GW": "Guinea-Bissau",
            "GY": "Guyana",
            "HK": "Hongkong SAR",
            "HM": "Heardön och McDonaldöarna",
            "HN": "Honduras",
            "HR": "Kroatien",
            "HT": "Haiti",
            "HU": "Ungern",
            "IC": "Kanarieöarna",
            "ID": "Indonesien",
            "IE": "Irland",
            "IL": "Israel",
            "IM": "Isle of Man",
            "IN": "Indien",
            "IO": "Brittiska territoriet i Indiska oceanen",
            "IQ": "Irak",
            "IR": "Iran",
            "IS": "Island",
            "IT": "Italien",
            "JE": "Jersey",
            "JM": "Jamaica",
            "JO": "Jordanien",
            "JP": "Japan",
            "KE": "Kenya",
            "KG": "Kirgizistan",
            "KH": "Kambodja",
            "KI": "Kiribati",
            "KM": "Komorerna",
            "KN": "S:t Kitts och Nevis",
            "KP": "Nordkorea",
            "KR": "Sydkorea",
            "KW": "Kuwait",
            "KY": "Caymanöarna",
            "KZ": "Kazakstan",
            "LA": "Laos",
            "LB": "Libanon",
            "LC": "S:t Lucia",
            "LI": "Liechtenstein",
            "LK": "Sri Lanka",
            "LR": "Liberia",
            "LS": "Lesotho",
            "LT": "Litauen",
            "LU": "Luxemburg",
            "LV": "Lettland",
            "LY": "Libyen",
            "MA": "Marocko",
            "MC": "Monaco",
            "MD": "Moldavien",
            "ME": "Montenegro",
            "MF": "Saint-Martin",
            "MG": "Madagaskar",
            "MH": "Marshallöarna",
            "MK": "Nordmakedonien",
            "ML": "Mali",
            "MM": "Myanmar (Burma)",
            "MN": "Mongoliet",
            "MO": "Macao SAR",
            "MP": "Nordmarianerna",
            "MQ": "Martinique",
            "MR": "Mauretanien",
            "MS": "Montserrat",
            "MT": "Malta",
            "MU": "Mauritius",
            "MV": "Maldiverna",
            "MW": "Malawi",
            "MX": "Mexiko",
            "MY": "Malaysia",
            "MZ": "Moçambique",
            "NA": "Namibia",
            "NC": "Nya Kaledonien",
            "NE": "Niger",
            "NF": "Norfolkön",
            "NG": "Nigeria",
            "NI": "Nicaragua",
            "NL": "Nederländerna",
            "NO": "Norge",
            "NP": "Nepal",
            "NR": "Nauru",
            "NU": "Niue",
            "NZ": "Nya Zeeland",
            "OM": "Oman",
            "PA": "Panama",
            "PE": "Peru",
            "PF": "Franska Polynesien",
            "PG": "Papua Nya Guinea",
            "PH": "Filippinerna",
            "PK": "Pakistan",
            "PL": "Polen",
            "PM": "S:t Pierre och Miquelon",
            "PN": "Pitcairnöarna",
            "PR": "Puerto Rico",
            "PS": "Palestinska territorierna",
            "PT": "Portugal",
            "PW": "Palau",
            "PY": "Paraguay",
            "QA": "Qatar",
            "QO": "yttre öar i Oceanien",
            "RE": "Réunion",
            "RO": "Rumänien",
            "RS": "Serbien",
            "RU": "Ryssland",
            "RW": "Rwanda",
            "SA": "Saudiarabien",
            "SB": "Salomonöarna",
            "SC": "Seychellerna",
            "SD": "Sudan",          
            "SG": "Singapore",
            "SH": "S:t Helena",
            "SI": "Slovenien",
            "SJ": "Svalbard och Jan Mayen",
            "SK": "Slovakien",
            "SL": "Sierra Leone",
            "SM": "San Marino",
            "SN": "Senegal",
            "SO": "Somalia",
            "SR": "Surinam",
            "SS": "Sydsudan",
            "ST": "São Tomé och Príncipe",
            "SV": "El Salvador",
            "SX": "Sint Maarten",
            "SY": "Syrien",
            "SZ": "Swaziland",
            "TA": "Tristan da Cunha",
            "TC": "Turks- och Caicosöarna",
            "TD": "Tchad",
            "TF": "Franska sydterritorierna",
            "TG": "Togo",
            "TH": "Thailand",
            "TJ": "Tadzjikistan",
            "TK": "Tokelauöarna",
            "TL": "Östtimor",
            "TM": "Turkmenistan",
            "TN": "Tunisien",
            "TO": "Tonga",
            "TR": "Turkiet",
            "TT": "Trinidad och Tobago",
            "TV": "Tuvalu",
            "TW": "Taiwan",
            "TZ": "Tanzania",
            "UA": "Ukraina",
            "UG": "Uganda",
            "UM": "USA:s yttre öar",
            "US": "USA",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VA": "Vatikanstaten",
            "VC": "S:t Vincent och Grenadinerna",
            "VE": "Venezuela",
            "VG": "Brittiska Jungfruöarna",
            "VI": "Amerikanska Jungfruöarna",
            "VN": "Vietnam",
            "VU": "Vanuatu",
            "WF": "Wallis- och Futunaöarna",
            "WS": "Samoa",
            "XK": "Kosovo",
            "YE": "Jemen",
            "YT": "Mayotte",
            "ZA": "Sydafrika",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        }
    }
});




let strings = new LocalizedStrings({
    fi: {
        yes: "Kyllä",
        contactType:"Tarjouksen tyyppi",
        sliderDescriptionPlanType: "Valitse tapa, jolla haluat aloittaa saunasi suunnittelun.",
        sliderDescriptionProductGroups: "Valitse tarjoukseen sisällytettävät tuoteryhmät. Voit tarkentaa valintoja seuraavissa vaiheissa.",
        sliderDescriptionBenchModel: "Valitse saunasi tyyli. Voit tarkentaa lauteiden yksityiskohtia seuraavissa vaiheissa.",
        sliderDescriptionMeasurements: "Syötä saunan tilan suuntaa-antavat mitat. Tarkemmat mitat varmistetaan ennen toimitusta.",
        sliderDescriptionBenchShape: "Valitse tilaan sopiva lauteiden muoto. Voit vaihtaa kätisyyttä tarvittaessa.",
        sliderDescriptionPositioning: "Aseta kiuas ja ovi paikoilleen pohjakuvassa.",
        sliderDescriptionBenchMaterial: "Valitse lauteisiin sopiva materiaali ja vertaa vaihtoehtoja esikatselussa.",
        sliderDescriptionPanelMaterial: "Valitse saunaan sopiva paneelimateriaali.",
        sliderDescriptionLights: "Valitse saunaan sopiva valaistusratkaisu.",
        sliderDescriptionStove: "Valitse kiuas ja tarkista sen tiedot.",
        sliderDescriptionGlassWall: "Valitse lasiseinä- tai oviratkaisu sekä materiaalit.",
        sliderDescriptionInstallation: "Valitse haluatko asennuksen mukaan tarjoukseen.",
        sliderDescriptionContactDetails: "Tarkista valinnat ja lähetä suunnitelma sekä tarjouspyyntö.",
        wantToDesign: "Suunnittele saunasi suunnittelu&shy;ohjelmalla.",
        wantToLeaveContactDetails: "Jätä nopea tarjous- tai yhteyden&shy;otto&shy;pyyntö",
        designPathDescription:"Valitse tämä vaihtoehto, mikäli haluat suunnitella saunasi suunnittelu&shy;ohjelmalla. Ohjelmalla voit valita haluamasi tuotteet ja materiaalit sekä muokata niiden ominaisuuksia ja määrittää mitat. ",
        contactPathDescription: "Valitse tämä vaihtoehto, mikäli haluat vain jättää yhteystietosi, sekä antaa perustiedot kohteesta.",
        saunaPlanner: "Saunamuokkain",
        appInMaintenanceState:"Ohjema vikatilassa. Yritä myöhemmin uudelleen",
        chooseProducts: "Valitse tarjouksen tuotteet",
        chooseAtLeastOneProduct: "Valitse vähintään yksi tuote",
        doorProductGroup: "Lasiseinä tai karmillinen ovi",
        designDreamSauna: "Suunnittele unelmiesi sauna- saat ilmaisen suunnitelman, 3D-kuvan ja kustannusarvion saunastasi.",
        chooseBenchModel: "Valitse lauteiden malllisto",
        chooseBenchModelInfo:"Tällä sivulla valitaan lauteiden mallisto/muotokieli. Lauteen muotoa pääset suunnittelemaan tarkemmin seuraavilla sivuilla.",
        chooseThisModel: "Valitse tämä mallisto",
        selectBenchModel:"Valitse sopiva laudemallisto.",
        chooseThisShape: "Valitse tämä malli",
        chooseBenchShape: "Valitse lauteiden muoto",
        selectBenchShape: "Valitse sopiva lauteiden muoto",
        unavailableBenchShapes: "Saunan mitat eiv\u00e4t riit\u00e4 n\u00e4ille malleille",
        unavailableBenchShapesInfo: "N\u00e4m\u00e4 laudemallit tarvitsevat suuremman saunan.",
        chooseDoor: "Oven valinta",
        creatingBenchPicture: "Luodaan laudekuvaa",
        materialSelection: "Materiaalivalinta",
        panelMaterialSelection: "Panelointi",
        benchMaterialSelection: "Laudemateriaali",
        benches: "Lauteet",
        lightSelection: "Valaistus",
        selected: "Valittu",
        notSelected: "Ei valittu",
        stoveAndLigthSelection: "Kiuas",
        changeHandedness: "Vaihda kätisyys",
        changeDoorHandedness: "Vaihda oven kätisyys",
        profileMaterial: "Profiilimateriaali",
        paneling: "Panelointi",
        benchMaterial: "Laudemateriaali",
        noPaneling: "Ei panelointia",
        panelMaterial: "Paneelimateriaali",
        panelingDirection: "Panelointisuunta",
        glassColor: "Lasin sävy",
        stove: "Kiuas",
        vertical: "pysty",
        horizontal: "vaaka",
        ligthing: "Valaistus",
        ownLighs: "Hankin itse valaistuksen",
        benchLight: "Laudekuituvalaisin",
        roofLigth: "Kattovalaisin kiuaslinssillä",
        benchLigthWithStoveLight: "Laudekuituvalaisin kiuaslinssillä",
        roofLigthWithBenchLight: "Kattovalaisin kiuaslinsillä",
        linearLight: "Linear LED valaistus",
        linearBarWithStoveLight: "Linear LED valaistus kiuaslinssillä",
        ledStripe: "LED-nauhavalaistus",
        ledStripeWithStoveLight: "LED-nauhavalaistus kiuasvalolla",
        prevPhase: "Edellinen",
        nextPhase: "Seuraava",
        giveSaunaMeasurements: "Anna tilan mitat",        
        writeDownSaunanMeasurements: "Kirjoita alle tilan mitat. Mittojen ei tarvitse olla tarkkoja, sillä ne tarkastetaan ennen toimitusta. Mikäli tila ei ole nelikulmainen, voit myös ladata pohjakuvan.",
        doorWallWidth: "Oviseinän leveys",
        depth: "Syvyys",
        height: "Korkeus",
        doorWidth: "Oven leveys",
        saunaDepth: "Saunan syvyys",
        saunaHeight: "Saunan korkeus",
        saunaDoorWidth: "Saunan oven leveys",
        noMeasurements: "Ei mittoja? Ohita tämä vaihe",
        commentMeasurements:"Lisätietoa mitoista",
        missingDetail: "Puuttuva tieto",
        dragDoorAndStoveToPlace: "Raahaa kiuas ja ovi paikoilleen",
        restoreDefaultPositions: "Palauta oletussijainnit",
        restoreGlassWallDefaults: "Palauta lasiseinän oletukset",
        dragStoveToPlace: "Raahaa kiuas haluamallesi paikalle.",
        dragDoorToPlace: "Raahaa ovi haluamallesi paikalle.",
        positioningForDoorAndStove: "Kiukaan ja oven asettelu",
        doorPageHeader: "Oven valinta",
        doorTypeSelectionLabel: "Haluan tarjouksen:",
        fullGlassWall: "Kokolasiseinästä",
        halfGlassWall: "Puolilasiseinästä",
        onlyGlassDoor: "Karmittomasta ovesta",
        doorWithCarms: "Tervaleppäkarmisesta ovesta",
        fittingAndListColor:"Listojen ja helojen väri",
        customGlassWall: "Mittatilaus lasiseinästä",
        ownDoor: "Hankin lasiseinän/oven itse",
        glassMaterialHeader: "Lasimateriaali",
        finishPlan: "Viimeistele suunnitelma",
        downloadPlan: "Lataa suunnitelma sähköpostiisi",
        leaveQuickOffer: "Jätä nopea tarjouspyyntö",
        quickOfferDescription:"(Kerro lyhyesti mistä tuotteista ja palveluista haluat tarjouksen)",
        giveContactDetails: "Anna alle yhteystietosi, niin saat kustannusarvion sähköpostiisi.",
        name: "Nimi",
        city: "Kaupunki",
        postalNumber: "Postinro.",
        address: "Osoite",
        phone: "Puhelin",
        email: "Sähköposti",
        country: "Maa",
        notes: "Lisätietoja tarjouspyynnöstä",
        namePlaceHolder: "Kirjoita nimesi tähän...",
        cityPlaceHolder: "Kirjoita postitoimipakka tähän...",
        postalNumberPlaceHolder: "Kirjoita postinumero tähän...",
        addressPlaceHolder: "Kirjoita katuosoite tähän...",
        phonePlaceHolder: "Kirjoita puhelinumero tähän...",
        emailPlaceHolder: "Kirjoita sähköpostiosoitteesi tähän...",
        attachment: "Liite",
        sendOffer: "Lataa suunnitelma sähköpostiisi.",
        emailOrPhone: "Sähköposti tai puhelin täytyy antaa.",
        errorInEmail: "Virheellinen sähköposti",
        thankYou: "Kiitos!",
        sendingOfferRequest: "Lähetetään tarjouspyyntöä.",
        offerRequestSent: "Kiitos, tarjouspyyntö lähetetty",
        projectExtraInfo: "Lisätieto projektista",
        install: "Asennus",
        wantInstall: "Haluatko tarjouksen asennuksesta ?",
        installSelf: "Asennan itse",
        fillInstallPostalCode: "Syötä postinumerosi, niin näet onko asennus saatavilla alueellesi.",
        installPossibleInArea: "Asennus saatavilla alueellesi. Valitse projektin tyyppi",
        installNotPossibleInArea: "Asennusta ei saataavilla alueellesi. Voit kuitenkin jättää tarjouspyynnön ja myyjämme voi löytää sopivan yhteistyökumppanin asennukseen.",
        checking:"Tarkastetaan asennuksen saatavuutta",
        newConstruction: "Uudisrakennus",
        renowation: "Remontti",
        chooseInstallProducts: "Valitse asennustuotteet",
        doorInstall: "Oven/lasiseinän asennus",
        measurementVisit:"Haluan myös mittakäynnin (JKL,PK-seutu, Turku 80-150 €)",
        demolutionWork:"Purkutyöt(sis. Uudet eristeet ja rimat, sekä saunan mittauksen)",
        baseWork: "Pohjatyöt(sis. eristeet, rimat, vaahdot ja teipit)",
        installDate:"Toivottu ajankohta",
        installExtraDescription:"Lisätietoja projektista",
        thankYouMainlabel: "Saatte suunnitelmanne sekä selkeän kustannusarvion sähköpostiinne kahden työpäivän kuluessa.",
        makeNewPlan: "Tee uusi suunnitelma",
        minimum: "Minimi",
        maximum: "Maksimi",
        invalidEmail: "Virheellinen sähköposti",
        invalidPhonenumber: "Virheellinen puhelinumero",
        minimumMeasurements: "Saunan minimimitat",
        recommendedMeasurements: "Saunan suositusmitat",
        currentMeasurements: "Nykyiset mitat:",
        consent: "Sallin tietojeni tallentamisen Sun Sauna OY:n asiakasrekisteriin.",
        privacyStatement: "Tietosuojaseloste",
        changesComplete: "Muutokset tallennettu",
        changeSelllerContact: "Saatte vielä vahvistuksen tekemistänne muutoksista sähköpostiinne.",
        total: "Yhteensä",
        planSentPreviously: "Olette jo lähettäneet tämän saunasuunnitelman eteenpäin. Mikäli haluatte tehdä siihen muutoksia olkaa yhteydessä myyjäänne.",
        sendOfferRequest: "Lähetä tarjouspyyntö",
        descriptionClassic: "Pehmein ja pyörein linjoin muotoillut lauteet miellyttävät silmää ja tuovat saunomiseen mukavuutta.Todellinen kestosuosikki, suosituin laudemalli jo 20-vuoden ajan.",
        descriptionRelax: "Suoralinjaista, pelkistettyä ja aikaa kestävää. Konstailematonta ulkonäköä laadukkaasti toteutettuna.",
        descriptionRelaxXL: "Perinteikäs Relax-laude seinään jatkuvalla alalauteella ilman väliritlöitä.",
        descriptionLog: "Leveästä massiivilankusta valmistettu laude joka henkii perinteisen suomalaisen savusaunan tunnelmaa myös kaupunkikodissa. Valmistetaan mustaksi sävytettynä tai käsittelemättömänä.",
        descriptionWave: "Leveät laudelaudat yhdistettynä kaareviin muotoihin. Puusepän taidonnäyte jossa laudelaudoitus kulkee pitkittäissuuntaisesti myös lauteen parhaalla kulmapaikalla.",
        descriptionElegance: "Klassinen säteittäinen kulmalaude päivitettynä nykyaikaisiin selkeisiin muotoihin ja normaalia leveämpiin laudemateriaaleihin. Lauteen istuinosan laudelaudat ovat syvyyssuunnassa.",
        descriptionBasic: "Edullinen ja käytännöllinen sekä muotokieleltään perinteinen laudemalli.",
        straightWithoutEmbedding: "Suora ilman upotusta",
        straight: "Suora",
        lModel: "L-malli",
        largeLModel: "Iso L- malli",
        straightWithEmbedding: "Suora kiuasupotuksella",
        uModelWithoutEmbedding: "U-malli ilman upotusta",
        lModelWithoutEmbedding: "L-malli ilman upotusta",
        lModelWithEmbedding: "L-malli kiuasupotuksella",
        largeUModelWithoutEmbedding: "Iso U-malli ilman upotusta",
        largeLModelWithoutEmbedding: "Iso L-malli ilman upotusta",
        largeLModelWithEmbedding: "Iso L-malli kiuasupotuksella",
        largeUModelWithEmbedding: "Iso U-malli kiuasupotuksella",
        oppositeLModel: "Vastakkainen L-malli",
        oppositeStraightModel: "Vastakkainen suora",
        uModelWithEmbedding: "U-malli kiuasupotuksella",
        thisDetailRequired: "Tämä kohta vaaditaan",
        emailOrPhoneIsRequired: "Sähköposti tai Puhelin täytyy antaa.",
        measurementsOrFloorImage: "Syötä mitat tai lataa pohjakuva",
        contactAsSoonAsPossible: "Olemme teihin yhteydessä mahdollisimman pian.",
        askFeedBack:"Halutessanne voitte vielä antaa palautetta tarjousohjelmastamme.",      
        askHowEasy: "Kuinka helposti tarjouspyynnön tekeminen sujui?",
        sendFeedback: "Lähetä palautetta",
        thankYouForFeedback: "Kiitos palautteestanne.",
        floorImage: "Tilan pohjakuva",
        failedRequestMessage: "Tallennus epäonnistui. Tarkasta verkkoyhteyksien toiminta ja yritä myöhemmin uudelleen.",
        askResellerAssistance:"Pyydän tarjouksen tarkistusta"
    },
    en: {
        yes: "Yes",
        contactType: "Type of offer",
        sliderDescriptionPlanType: "Choose how you want to start designing your sauna.",
        sliderDescriptionProductGroups: "Choose the product groups to include in the quote. You can refine your choices in the following steps.",
        sliderDescriptionBenchModel: "Choose the style of your sauna. You can refine the bench details in the following steps.",
        sliderDescriptionMeasurements: "Enter approximate measurements for the sauna space. The exact measurements will be verified before delivery.",
        sliderDescriptionBenchShape: "Choose a bench shape that fits the space. You can change its handedness if necessary.",
        sliderDescriptionPositioning: "Position the stove and door on the floor plan.",
        sliderDescriptionBenchMaterial: "Choose a suitable bench material and compare the options in the preview.",
        sliderDescriptionPanelMaterial: "Choose a suitable panel material for the sauna.",
        sliderDescriptionLights: "Choose a suitable lighting solution for the sauna.",
        sliderDescriptionStove: "Choose a stove and review its details.",
        sliderDescriptionGlassWall: "Choose a glass wall or door solution and its materials.",
        sliderDescriptionInstallation: "Choose whether to include installation in the quote.",
        sliderDescriptionContactDetails: "Review your choices and submit the plan and quote request.",
        saunaPlanner: "Sauna planner",
        wantToDesign: "Design your sauna with our sauna planner.",
        wantToLeaveContactDetails: "Leave a quick request for a quote or contact.",
        designPathDescription: "Choose this option if you want to design your sauna using the planner. You can select products and materials, adjust their properties, and define the measurements.",
        contactPathDescription: "Choose this option if you only want to leave your contact details and basic information about the project.",
        chooseProducts: "Choose products for your quote",
        appInMaintenanceState: "App in maintenance mode. Please try again later.",
        chooseAtLeastOneProduct: "Select at least one product",
        doorProductGroup: "Glass wall or framed door",
        designDreamSauna: "Design your dream sauna – get a free plan, 3D image and cost estimate.",
        chooseBenchModel: "Choose bench model collection",
        chooseBenchModelInfo: "On this page you select the bench model / design language. You can design the bench shape in more detail on the next pages.",
        chooseThisModel: "Choose this model",
        selectBenchModel: "Select a suitable bench model collection.",
        chooseThisShape: "Choose this shape",
        chooseBenchShape: "Choose bench shape",
        selectBenchShape: "Select a suitable bench shape",
        unavailableBenchShapes: "These models do not fit",
        unavailableBenchShapesInfo: "These bench shapes need a larger sauna than the measurements entered.",
        creatingBenchPicture: "Creating bench image",
        materialSelection: "Material selection",
        panelMaterialSelection: "Paneling",
        benchMaterialSelection: "Bench material",
        chooseDoor: "Choose door",
        selected: "Selected",
        notSelected: "Not selected",
        benches: "Benches",
        lightSelection: "Lighting",
        stoveAndLigthSelection: "Stove",
        profileMaterial: "Profile material",
        benchMaterial: "Bench material",
        panelMaterial: "Panel material",
        changeHandedness: "Change handedness",
        changeDoorHandedness: "Change door handedness",
        paneling: "Paneling",
        noPaneling: "No paneling",
        panelingDirection: "Paneling direction",
        stove: "Stove",
        vertical: "Vertical",
        horizontal: "Horizontal",
        ligthing: "Lighting",
        ownLighs: "I will provide my own lighting",
        benchLight: "Bench light",
        roofLigth: "Ceiling light with stove lens",
        benchLigthWithStoveLight: "Bench light with stove lens",
        roofLigthWithBenchLight: "Ceiling light with bench light",
        linearLight: "Linear LED lighting",
        linearBarWithStoveLight: "Linear LED lighting with stove lens",
        ledStripe: "LED strip lighting",
        ledStripeWithStoveLight: "LED strip lighting with stove light",
        prevPhase: "Previous",
        nextPhase: "Next",
        giveSaunaMeasurements: "Give room measurements",
        writeDownSaunanMeasurements: "Write the room measurements below. They do not need to be exact as they will be verified before delivery. If the room is not rectangular, you can also upload a floor plan.",
        doorWallWidth: "Door wall width",
        depth: "Depth",
        height: "Height",
        doorWidth: "Door width",
        saunaDoorWidth: "Sauna door width",
        saunaDepth: "Sauna depth",
        saunaHeight: "Sauna height",
        fittingAndListColor: "List and fitting color",
        install: "Installation",
        wantInstall: "Do you want an installation offer?",
        installSelf: "I will install myself",
        fillInstallPostalCode: "Enter your postal code to check installation availability.",
        installPossibleInArea: "Installation is available in your area. Select project type.",
        installNotPossibleInArea: "Installation is not available in your area. You may still request a quote, and our sales team may find a suitable installation partner.",
        checking: "Checking installation availability",
        newConstruction: "New construction",
        renowation: "Renovation",
        chooseInstallProducts: "Choose installation items",
        doorInstall: "Door/glass wall installation",
        measurementVisit: "I also want a measurement visit (Helsinki region, Jyväskylä, Turku 80-150 €)",
        demolutionWork: "Demolition work (incl. new insulation, battens, and sauna measurement)",
        baseWork: "Base work (incl. insulation, battens, foam and tapes)",
        installDate: "Preferred installation time",
        installExtraDescription: "Additional project details",
        noMeasurements: "No measurements? Skip this step",
        commentMeasurements: "Additional information about measurements",
        missingDetail: "Missing detail",
        minimum: "Minimum",
        maximum: "Maximum",
        invalidEmail: "Invalid email",
        invalidPhonenumber: "Invalid phone number",
        dragDoorAndStoveToPlace: "Drag the stove and door to their positions",
        restoreDefaultPositions: "Restore default positions",
        restoreGlassWallDefaults: "Restore glass wall defaults",
        dragStoveToPlace: "Drag the stove to your desired location.",
        dragDoorToPlace: "Drag the door to your desired location.",

        downloadPlan: "Download the plan to your email",
        leaveQuickOffer: "Leave a quick quote request",
        quickOfferDescription: "(Briefly describe which products and services you want a quote for)",
        doorPageHeader: "Door selection",
        doorTypeSelectionLabel: "I want a quote for:",
        fullGlassWall: "Full glass wall",
        halfGlassWall: "Half glass wall",
        onlyGlassDoor: "Frameless door",
        doorWithCarms: "Alder-framed door",
        customGlassWall: "Custom-sized glass wall",
        ownDoor: "I will provide my own glass wall/door",
        glassMaterialHeader: "Glass material",
        finishPlan: "Finish plan",
        giveContactDetails: "Enter your contact details below to receive the cost estimate.",
        name: "Name",
        city: "City",
        postalNumber: "Postal code",
        address: "Address",
        phone: "Phone",
        email: "Email",
        country: "Country",
        notes: "Additional information for the quote",
        attachment: "Attachment",
        namePlaceHolder: "Write your name here...",
        cityPlaceHolder: "Write your city here...",
        postalNumberPlaceHolder: "Enter your postal code...",
        addressPlaceHolder: "Enter your street address...",
        phonePlaceHolder: "Enter your phone number...",
        emailPlaceHolder: "Enter your email address...",
        sendOffer: "Download the plan to your email.",
        emailOrPhone: "Email or phone is required.",
        errorInEmail: "Invalid email",
        thankYou: "Thank you!",
        sendingOfferRequest: "Sending quote request.",
        offerRequestSent: "Thank you, your quote request has been sent.",
        thankYouMainlabel: "You will receive your plan and a clear cost estimate by email within two working days.",
        makeNewPlan: "Create a new plan",
        recommendedMeasurements: "Recommended measurements:",
        minimumMeasurements: "Minimum measurements:",
        currentMeasurements: "Current measurements:",
        positioningForDoorAndStove: "Position door and stove",
        projectExtraInfo: "Additional project information",
        consent: "I consent to my data being stored in Sun Sauna Oy’s customer register.",
        privacyStatement: "Privacy statement",
        glassColor: "Glass color",
        changesComplete: "Changes saved",
        changeSelllerContact: "You will receive confirmation of your changes by email.",
        sendOfferRequest: "Send quote request",
        total: "Total",
        planSentPreviously: "You have already sent this sauna plan. If you want to make changes, please contact your salesperson.",
        descriptionClassic: "Benches shaped with soft, rounded lines offering comfort and timeless appeal. A true long-time favorite for over 20 years.",
        descriptionRelax: "Straight-lined, minimalistic and timeless. Clean design executed with high quality.",
        descriptionRelaxXL: "Traditional Relax bench with a continuous lower bench extending to the wall without intermediate supports.",
        descriptionLog: "A bench made of wide solid planks, evoking the atmosphere of a traditional Finnish smoke sauna even in an urban home. Available black-tinted or untreated.",
        descriptionWave: "Wide bench boards combined with curved shapes. A carpentry masterpiece where the bench boards run lengthwise even at the best corner spot.",
        descriptionElegance: "A classic radial corner bench updated with modern clean lines and wider bench materials. The seat boards run in the depth direction.",
        straightWithoutEmbedding: "Straight without stove embed",
        straightWithEmbedding: "Straight with stove embed",
        uModelWithoutEmbedding: "U-model without stove embed",
        lModelWithoutEmbedding: "L-model without stove embed",
        lModelWithEmbedding: "L-model with stove embed",
        largeUModelWithoutEmbedding: "Large U-model without stove embed",
        largeLModelWithoutEmbedding: "Large L-model without stove embed",
        largeLModelWithEmbedding: "Large L-model with stove embed",
        largeUModelWithEmbedding: "Large U-model with stove embed",
        oppositeLModel: "Opposite L-model",
        oppositeStraightModel: "Opposite straight model",
        uModelWithEmbedding: "U-model with stove embed",
        thisDetailRequired: "This field is required",
        emailOrPhoneIsRequired: "Email or phone number must be provided.",
        measurementsOrFloorImage: "Enter measurements or upload a floor plan.",
        floorImage: "Floor plan image",
        thankYouWithFeedback: "Thank you for your feedback.",
        askHowEasy: "How easy was it to submit a quote request?",
        sendFeedback: "Send feedback",
        failedRequestMessage: "Saving failed. Please check your network connection and try again later.",
        askResellerAssistance: "Request assistance from reseller"
    },
    sv:
    {
        yes: "Ja",
        contactType: "Anbudstyp",
        sliderDescriptionPlanType: "Välj hur du vill börja planera din bastu.",
        sliderDescriptionProductGroups: "Välj de produktgrupper som ska ingå i offerten. Du kan precisera dina val i följande steg.",
        sliderDescriptionBenchModel: "Välj stil för din bastu. Du kan precisera detaljerna för lavarna i följande steg.",
        sliderDescriptionMeasurements: "Ange ungefärliga mått för bastuutrymmet. De exakta måtten kontrolleras före leverans.",
        sliderDescriptionBenchShape: "Välj en form på lavarna som passar utrymmet. Du kan byta riktning vid behov.",
        sliderDescriptionPositioning: "Placera aggregatet och dörren på planritningen.",
        sliderDescriptionBenchMaterial: "Välj ett lämpligt material för lavarna och jämför alternativen i förhandsgranskningen.",
        sliderDescriptionPanelMaterial: "Välj ett lämpligt panelmaterial för bastun.",
        sliderDescriptionLights: "Välj en lämplig belysningslösning för bastun.",
        sliderDescriptionStove: "Välj ett aggregat och kontrollera dess uppgifter.",
        sliderDescriptionGlassWall: "Välj en glasväggs- eller dörrlösning samt material.",
        sliderDescriptionInstallation: "Välj om installation ska ingå i offerten.",
        sliderDescriptionContactDetails: "Kontrollera dina val och skicka planen samt offertförfrågan.",
        wantToDesign: "Designa din bastu med designprogram",
        wantToLeaveContactDetails: "Lämna en snabb offert- eller kontaktbegäran",
        designPathDescription: "Välj detta alternativ om du vill designa din bastu med ett designprogram. Med programmet kan du välja de produkter och material du önskar, samt redigera deras egenskaper och ange mått.",
        contactPathDescription: "Välj detta alternativ om du bara vill lämna dina kontaktuppgifter och ge grundläggande information om projektet.",
        downloadPlan: "Ladda planen till din e-post.",
        leaveQuickOffer: "Lämna en snabb offertförfrågan",
        quickOfferDescription: "(Berätta kort om vilka produkter och tjänster du vill ha ett erbjudande om)",
        saunaPlanner: "Basturedigeraren",
        appInMaintenanceState: "Program i felläge. Försök igen senare.",
        chooseAtLeastOneProduct: "Välj minst en produkt",
        doorProductGroup: "Glasvägg eller dörr med karm",
        chooseProducts: "Välj produkter till anbudet",
        designDreamSauna: "Planera din drömbastu – få en gratis plan, en 3D-bild och en kostnadsberäkning för din bastu.",
        chooseBenchModel: "Välj en lavkollektion",
        chooseThisModel: "Välj den här kollektionen",
        selectBenchModel: "Välj en lämplig lavkollektion",
        chooseThisShape: "Välj den här modellen",
        selectBenchShape: "Välj formen på lavarna",
        chooseBenchModelInfo: "På denna sida väljs bastuns modell/utseende. Du kan designa bastuns form mer detaljerat på följande sidor.",
        chooseBenchShape: "Välj lavarnas form",
        unavailableBenchShapes: "M\u00e5tten r\u00e4cker inte f\u00f6r dessa modeller",
        unavailableBenchShapesInfo: "Dessa lavmodeller beh\u00f6ver en st\u00f6rre bastu.",
        creatingBenchPicture: "Skapar en bild av laven",
        materialSelection: "Val av material",
        panelMaterialSelection: "Panelsättning",
        chooseDoor: "Val av dörr",
        benchMaterialSelection: "Material till lave",
        selected: "Vald",
        notSelected: "Ej vald",
        benches: "Lavarna",
        lightSelection: "Bastubelysning",
        stoveAndLigthSelection: "Bastuaggregat",
        profileMaterial: "Profilmaterial",
        benchMaterial: "Material till lave",
        glassColor: "Glasets nyans",
        panelMaterial: "Panelmaterial",
        paneling: "Panelsättning",
        noPaneling: "Ingen panel",
        changeHandedness: "Byt hänthet",
        changeDoorHandedness: "Byt dörrens hängning",
        panelingDirection: "Riktning för panelsättning",
        stove: "Bastuaggregat",
        vertical: "Lodrät",
        horizontal: "Vågrät",
        minimum: "Minimum",
        maximum: "Maximum",
        invalidEmail: "Ogiltig e-postadress",
        invalidPhonenumber: "Ogiltigt telefonnummer",
        ligthing: "Bastubelysning",
        ownLighs: "Jag skaffar belysningen själv",
        benchLight: "Lavbelysning",
        roofLigth: "Takbelysning",
        linearLight: "Linear LED-belysning",
        linearBarWithStoveLight: "Linear LED-belysning med aggregatlins",
        ledStripe: "LED-listbelysning",
        ledStripeWithStoveLight: "LED-listbelysning med aggregatbelysning",
        benchLigthWithStoveLight: "Lavbelysning med aggregatlins",
        roofLigthWithBenchLight: "Takbelysning med aggregatlins",
        prevPhase: "Gå till föregående steg",
        nextPhase: "Gå till nästa steg.",
        install: "Installation",
        wantInstall: "Vill du ha ett installationsanbud?",
        installSelf: "Jag installerar själv",
        fillInstallPostalCode: "Ange ditt postnummer för att se om installation finns tillgänglig i ditt område.",
        installPossibleInArea: "Installation är tillgänglig i ditt område. Välj projekttyp.",
        newConstruction: "Nybygge",
        renowation: "Renovering",
        chooseInstallProducts: "Välj installationstjänster",
        doorInstall: "Installation av dörr/glasvägg",
        installDate: "Önskad installationstid",
        measurementVisit: "Jag vill även ha ett mätbesök (Stockholm-regionen, JKL, Åbo 80–150 €)",
        demolutionWork: "Rivningsarbete (inkl. nya isoleringar, reglar och mätning av bastun)",
        baseWork: "Grundarbeten (inkl. isoleringar, reglar, skumning och tejpning)",
        installNotPossibleInArea: "Installation är inte tillgänglig i ditt område. Du kan ändå lämna en offertförfrågan så kan vår säljare eventuellt hitta en samarbetspartner.",
        checking: "Kontrollerar tillgänglighet...",
        installExtraDescription: "Mer information om projektet",
        giveSaunaMeasurements: "Ange utrymmets mått",
        writeDownSaunanMeasurements: "Ange utrymmets mått nedan",
        doorWallWidth: "Dörrväggens bredd",
        depth: "Djup",
        saunaDepth: "Bastuns djup",
        height: "Höjd",
        saunaHeight: "Bastuns höjd",
        doorWidth: "Dörrens bredd",
        saunaDoorWidth: "Bastudörrens bredd",
        noMeasurements: "Inga mått? Hoppa över detta steg",
        commentMeasurements: "Mer information om mått",
        missingDetail: "Information saknas",
        dragDoorAndStoveToPlace: "Dra aggregatet och dörren till sin plats",
        restoreDefaultPositions: "Återställ standardplaceringarna",
        restoreGlassWallDefaults: "Återställ glasväggens standardvärden",
        dragDoorToPlace: "Dra dörren till önskad plats.",
        dragStoveToPlace: "Dra aggregatet till önskad plats.",
        finishPlan: "Slutför planen",
        doorPageHeader: "Val av dörr",
        doorTypeSelectionLabel: "Jag vill ha ett anbud:",
        fullGlassWall: "På en glasvägg i fullhöjd",
        halfGlassWall: "På en glasvägg i halvhöjd",
        onlyGlassDoor: "På en dörr utan karm",
        fittingAndListColor: "Färg av lister och beslag",
        doorWithCarms: "På en dörrkarm i klibbal och en dörr",
        customGlassWall: "På en måttbeställd glasvägg",
        ownDoor: "Jag skaffar glasväggen/glasdörren själv",
        glassMaterialHeader: "Glasmaterial",
        giveContactDetails: "Ge dina kontaktuppgifter nedan, så får du planen med kostnadsberäkning skickad till din e-post.",
        name: "Namn",
        city: "Verksamhetsställe",
        postalNumber: "Postnummer",
        address: "Adress",
        phone: "Telefonnummer",
        email: "E-postadress",
        country: "Land",
        attachment: "Bilaga",
        notes: "Mer information om anbudsbegäran",
        namePlaceHolder: "Skriv ditt namn här...",
        cityPlaceHolder: "Skriv din stad/ort här...",
        postalNumberPlaceHolder: "Skriv ditt postnummer...",
        addressPlaceHolder: "Skriv din gatuadress...",
        phonePlaceHolder: "Skriv ditt telefonnummer...",
        emailPlaceHolder: "Skriv din e-postadress...",
        sendOffer: "Ladda planen till din e-post...",
        emailOrPhone: "Ange en e-postadress eller ett telefonnummer.",
        errorInEmail: "Ogiltig e-postadress",
        thankYou: "Tack!",
        sendingOfferRequest: "Anbudsbegäran skickas",
        offerRequestSent: "Tack, anbudsbegäran har skickats.",
        thankYouMainlabel: "Ni får er plan samt en tydlig kostnadsberäkning som e-post inom två arbetsdagar.",
        makeNewPlan: "Gör en ny plan",
        recommendedMeasurements: "Rekommenderade mått på bastun",
        minimumMeasurements: "Bastuns minimimått",
        positioningForDoorAndStove: "Placering av aggregat och dörr",
        consent: "Jag tillåter att mina uppgifter lagras i Sun Sauna OY:s kundregister.",
        currentMeasurements: "Nuvarande m\u00e5tt:",
        privacyStatement: "Sekretesspolicy",
        planSentPreviously: "Du har redan vidarebefordrat denna bastuplan. Om du vill göra ändringar, vänligen kontakta din säljare.",
        changeSelllerContact: "Du kommer att få en bekräftelse på dina ändringar via e-post.",
        projectExtraInfo: "Ange tilläggsinformation för projektet",
        changesComplete: "Ändringar sparade",
        sendOfferRequest: "Sänd offert",
        total: "Totalt",
        descriptionClassic: "Classic-kollektionen. Laven är utformad med mjuka och runda former som behagar ögat och gör bastubadandet bekvämt. En ständig favorit – den populäraste lavmodellen i över 20 år.",
        descriptionRelax: "Relax-kollektionen. Rätlinjig, avskalad och tidlös. Ett okonstlat utseende utfört med hög kvalitet.",
        descriptionRelaxXL: "Traditionell Relax-lave med en nedre lave som fortsätter mot väggen utan mellanribbor.",
        descriptionLog: "Log – en lave av breda massivplankor som ger känslan av en traditionell rökbastu, även i ett stadshem.",
        descriptionWave: "Wave-kollektionen. Breda lavbrädor kombinerat med mjuka kurvor. Ett hantverksprov där brädningen fortsätter längsgående även i hörnet.",
        descriptionElegance: "Elegance-kollektionen. En klassisk radiell hörnlave uppdaterad med moderna linjer och bredare lavmaterial. Brädorna i sittdelen går i djupled.",
        straightWithoutEmbedding: "Rak utan infällning",
        straightWithEmbedding: "Rak med aggregatinfällning",
        uModelWithoutEmbedding: "U-modell utan infällning",
        lModelWithoutEmbedding: "L-modell utan infällning",
        lModelWithEmbedding: "L-modell med aggregatinfällning",
        largeUModelWithoutEmbedding: "Stor U-modell utan infällning",
        largeLModelWithoutEmbedding: "Stor L-modell utan infällning",
        largeLModelWithEmbedding: "Stor L-modell med aggregatinfällning",
        oppositeLModel: "Motsatt L-modell",
        oppositeStraightModel: "Motsatt rak modell",
        uModelWithEmbedding: "U-modell med aggregatinfällning",
        largeUModelWithEmbedding: "Stor U-modell med aggregatinfällning",
        thisDetailRequired: "Denna uppgift krävs",
        emailOrPhoneIsRequired: "E-post eller telefon måste anges.",
        measurementsOrFloorImage: "Fyll i mått eller ladda upp mätbild.",
        floorImage: "Mätbild",
        failedRequestMessage: "Det gick inte att spara. Kontrollera dina nätverksanslutningar och försök igen senare.",
        thankYouWithFeedback: "Tack för er offertförfrågan. Vi kontaktar er så snart som möjligt. Om ni vill får ni gärna berätta hur enkelt det var att göra offertförfrågan.",
        askHowEasy: "Hur enkelt gick det att göra offertförfrågan?",
        sendFeedback: "Skicka feedback",
        askResellerAssistance: "Jag ber om hjälp av återförsäljare"
    }
});

strings.setLanguage("fi");
countries.setLanguage("fi");
export default strings;
export { countries };
